import { render } from "./CustomerFormSidebar.vue?vue&type=template&id=013417bc"
import script from "./CustomerFormSidebar.vue?vue&type=script&lang=js"
export * from "./CustomerFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__